// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1NyY9","label":"Section_label__qcbb0","contentWrap":"Section_contentWrap__3gQ4s","footer":"Section_footer__29H1R","footerInner":"Section_footerInner__24dvH"};